<template>
  <div class="message-container">
    <div class="message-wrapper">
      <!-- タイトル -->
      <p class="-title">
        <b>回答出力先を設定してください</b>
      </p>
      <!-- ファイル形式の選択 -->
      <p style="text-align: left; font-weight: 600;">ファイル形式を選択</p>
      <b-field grouped>
        <b-radio v-model="scenarioEdit.parameter.format" native-value="csv" :disabled="scenarioEdit.is_confirm">CSV</b-radio>
        <b-radio v-model="scenarioEdit.parameter.format" native-value="Excel" :disabled="scenarioEdit.is_confirm">Excel</b-radio>
        <b-radio v-model="scenarioEdit.parameter.format" native-value="SpreadSheet" :disabled="!isGoogleDriveAuth || scenarioEdit.is_confirm">Google SpreadSheet</b-radio>
      </b-field>
      <!-- 出力先の選択 -->
      <p style="text-align: left; font-weight: 600; padding-top: 16px;">出力先を選択</p>
      <b-field grouped>
        <b-radio v-model="scenarioEdit.parameter.output" native-value="mail" :disabled="scenarioEdit.is_confirm">メール添付</b-radio>
        <b-radio v-model="scenarioEdit.parameter.output" native-value="GoogleDrive" :disabled="!isGoogleDriveAuth || scenarioEdit.is_confirm">Google Drive</b-radio>
      </b-field>
      <div style="text-align: left;" v-if="!isSettingUser && scenarioEdit.parameter.output === 'GoogleDrive'">
        <p style="text-align: left;">
          ※別のユーザーがGoogleDrive設定済みです。
        </p>
        <p style="text-align: left;">
          　変更する際はご注意ください。
        </p>
      </div>
      <!-- メールアドレス入力 -->
      <b-field v-if="scenarioEdit.parameter.output === 'mail'">
        <b-input
          style="width: 80%;"
          placeholder="例：abc@xyz.com"
          v-model="scenarioEdit.parameter.mail_to"
          max-length="254"
          :disabled="scenarioEdit.parameter.output !== 'mail'"
        />
        <div style="margin: 4px;">へ送信</div>
      </b-field>
      <!-- 保存方法の選択 -->
      <div v-if="scenarioEdit.parameter.output === 'GoogleDrive' && isGoogleDriveAuth">
        <p style="text-align: left; font-weight: 600; padding-top: 16px;">保存方法を選択</p>
        <b-field>
          <b-switch
            style="width: 100%;"
            size="is-small"
            v-model="scenarioEdit.parameter.preserve"
            :disabled="scenarioEdit.parameter.format !== 'SpreadSheet' || scenarioEdit.is_confirm"
          >
            {{preserve()}}
          </b-switch>
        </b-field>
        <!-- 保存先の選択 -->
        <p style="text-align: left; font-weight: 600; padding-top: 16px;">保存先を選択</p>
        <!-- GoogleFriveフォルダ一覧 -->
        <div v-if="!scenarioEdit.parameter.drive_info || !isSettingUser">
          <!-- GoogleDrive保存情報なし -->
          <!-- または前回保存ユーザーと異なる時 -->
          <GoogleDriveFolderList
            style="width: 100%; padding: 16px;"
            :userId="userId"
            :isConfirm="scenarioEdit.is_confirm"
            @set-folder="setFolder"
          />
        </div>
        <div v-else>
          <!-- GoogleDrive保存情報あり -->
          <GoogleDriveFolderList
            style="width: 100%; padding: 16px;"
            :userId="userId"
            :folderId="scenarioEdit.parameter.drive_info.id"
            :folderName="scenarioEdit.parameter.drive_info.name"
            :mimeType="scenarioEdit.parameter.drive_info.mime_type"
            :folderPath="scenarioEdit.parameter.drive_info.folderPath"
            :isConfirm="scenarioEdit.is_confirm"
            @set-folder="setFolder"
          />
        </div>
        <!-- 出力ファイル名の入力 -->
        <p style="text-align: left; font-weight: 600;">出力ファイル名を入力</p>
        <b-field>
          <input
            style="width: 40%; is-small"
            placeholder="例：回答一覧"
            v-model="scenarioEdit.parameter.file_name"
            :disabled="scenarioEdit.is_confirm"
          />
          <div style="margin: 4px;">_＜訪問者名＞</div>
        </b-field>
      </div>
      <!-- 各出力に対する注釈 -->
      <p style="text-align: left;" v-if="isCsvToMail">
        ※CSVファイルをメールに添付して送信します
      </p>
      <p style="text-align: left;" v-if="isCsvToGoogle">
        ※CSVファイルをGoogleDriveにアップロードします
      </p>
      <p style="text-align: left;" v-if="isExcelToMail">
        ※Excelファイルをメールに添付して送信します
      </p>
      <p style="text-align: left;" v-if="isExcelToGogle">
        ※ExcelファイルをGoogleDriveにアップロードします
      </p>
      <p style="text-align: left;" v-if="isSpreadSheetToMail">
        ※スプレッドシートをGoogleDriveに生成してURLをメールで送信します
      </p>
      <p style="text-align: left;" v-if="isSpreadSheetToGoogle">
        ※スプレッドシートをGoogleDriveに生成します
      </p>
      <!-- GoogleDrive非連携時の注釈 -->
      <div style="text-align: left;" v-if="!isGoogleDriveAuth">
        <p style="text-align: left; padding-top: 16px;">
          ※現在このアカウントはGoogleDrive連携がされていません。
          連携を行う場合は「設定」> 「外部連携」 > 「GoogleDrive連携」より連携をお願いいたします。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleDriveFolderList from '@/components/organisms/common/GoogleDriveFolderList'

export default {
  components: {
    /** GoogleDrive一覧 */
    GoogleDriveFolderList,
  },
  props: {
    /** シナリオデータ */
    scenarioEdit: {
      type    : Object,
      required: false
    },
    /** GoogleDrive連携可否 */
    isGoogleDriveAuth: {
      type    : Boolean,
      required: false,
      default : false
    },
    /** GoogleDrive連携ユーザーID */
    userId: {
      type    : String,
      required: false,
      default : ''
    }
  },
  computed: {
    /** 保存方法(CSVをメール添付) */
    isCsvToMail () {
      return Boolean(this.scenarioEdit.parameter.format === 'csv' &&
                     this.scenarioEdit.parameter.output === 'mail')
    },
    /** 保存方法(CSVをGoogle Drive保存) */
    isCsvToGoogle () {
      return Boolean(this.scenarioEdit.parameter.format === 'csv' &&
                     this.scenarioEdit.parameter.output === 'GoogleDrive')
    },
    /** 保存方法(Excelをメール添付 */
    isExcelToMail () {
      return Boolean(this.scenarioEdit.parameter.format === 'Excel' &&
                     this.scenarioEdit.parameter.output === 'mail')
    },
    /** 保存方法(ExcelをGoogle Drive保存) */
    isExcelToGogle () {
      return Boolean(this.scenarioEdit.parameter.format === 'Excel' &&
                     this.scenarioEdit.parameter.output === 'GoogleDrive')
    },
    /** 保存方法(Google SpreadSheetをメール添付 */
    isSpreadSheetToMail () {
      return Boolean(this.scenarioEdit.parameter.format === 'SpreadSheet' &&
                     this.scenarioEdit.parameter.output === 'mail')
    },
    /** 保存方法(Google SpreadSheetをGoogle Drive保存 */
    isSpreadSheetToGoogle () {
      return Boolean(this.scenarioEdit.parameter.format === 'SpreadSheet' &&
                     this.scenarioEdit.parameter.output === 'GoogleDrive')
    },
    /** Google Drive連携可否 */
    isGoogleAuth () {
      return Boolean(!this.isGoogleDriveAuth &&
                     (this.scenarioEdit.parameter.format === 'SpreadSheet' ||
                      this.scenarioEdit.parameter.output === 'GoogleDrive'))
    },
    isSettingUser () {
      let result = false
      if (!this.scenarioEdit.parameter.user_uuid) {
        // 未設定
        result = true
      } else if (this.scenarioEdit.parameter.user_uuid === this.userId) {
        // 同一ユーザー設定済み
        result = true
      } else {
        // 他ユーザー設定済み
        result = false
      }
      return result
    }
  },
  mounted () {
    if (this.scenarioEdit.parameter.user_uuid &&
        this.scenarioEdit.parameter.user_uuid !== this.userId) {
      // 前回設定したユーザーと異なる場合は、一度GoogleDrive情報をクリアする
      this.scenarioEdit.parameter.drive_info = {
        id        : '',
        name      : '',
        mime_type : '',
        folderPath: []
      }
    }
  },
  methods: {
    /** 選択フォルダ保存 */
    setFolder (folderId, folderName, mimeType, folderPath) {
      // フォルダID保存
      this.scenarioEdit.parameter.drive_info.id         = folderId
      // フォルダ名保存
      this.scenarioEdit.parameter.drive_info.name       = folderName
      // MIMEタイプ保存
      this.scenarioEdit.parameter.drive_info.mime_type  = mimeType
      // フォルダパス保存
      this.scenarioEdit.parameter.drive_info.folderPath = folderPath
    },
    /** 保存方法 */
    preserve () {
      let dispPreserve = ''
      if (this.scenarioEdit.parameter.format === 'SpreadSheet') {
        // SpreadSheetの場合は上書きと追記が選択可能
        dispPreserve = this.scenarioEdit.parameter.preserve ? '上書き' : '追記'
      } else {
        // CSVとExcelは新規作成のみ
        this.scenarioEdit.parameter.preserve = false
        dispPreserve = '新規作成'
      }

      return dispPreserve
    }
  }
}
</script>

<style lang="scss" scoped>
.message-container {
  .message-wrapper {
    background-color:white;
    .-title {
      font-size: 16px;
      padding: 16px;
      text-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/chatbot/modals/ModalContentOutputParts.vue